
import { TableHeader } from '../DataTable';
import { ReactComponent as DescendingIcon } from '../../../assets/Icons/arrows/arrow-down.svg';
import { MouseEvent, ReactNode } from 'react';


export default function TableHeaderCell({ 
    header, 
    isSticky,
    isShadowShown,
    hasMoleculeHighlighting,
    sorting,
    checkboxComp,
}: {
    header: TableHeader,
    isSticky: boolean,
    isShadowShown: boolean,
    hasMoleculeHighlighting: boolean,
    sorting?: {
        sortableHeaders: string[],
        sortHeaders: (e: MouseEvent<HTMLButtonElement>, value: string) => void,
        sortByParam: string | null,
        sortOrderParam: 'desc' | 'asc' | null,
    },
    checkboxComp?: ReactNode,
}) {
    const { label, value, alignment, columnMetadata } = header;


    return (
        <th 
            className={`bg-secondary ${isSticky ? 'sticky left-0 z-20' : ''} ${isShadowShown ? 'shadow-left' : ''}`}
        >
            <div className={`flex ${alignment === 'left' ? 'justify-start' : 'justify-center'} items-center gap-2 py-4 px-6 min-w-[150px]`}>
                {checkboxComp && (
                    <div className='mr-4 flex justify-center items-center'>{checkboxComp}</div>
                )}
                {hasMoleculeHighlighting && (
                    <div className='mr-4'><div className='w-[20px]' /></div>
                )}
                {sorting && sorting.sortableHeaders.includes(value) ? (
                    <button 
                        className="group font-semibold text-nowrap text-default hover:text-disable transition-all text-[14px] flex justify-center items-center gap-2" 
                        onClick={(e: MouseEvent<HTMLButtonElement>) => { e.preventDefault(); sorting.sortHeaders(e, value) }}
                    >
                        {label}
                        {sorting.sortByParam === value ? (
                            <div className={`w-[16px] ${sorting.sortOrderParam === 'asc' ? 'rotate-180' : 'rotate-0'} transition-all`}><DescendingIcon /></div>
                        ) : (
                            <div className={`w-[16px] transition-all hidden group-hover:block`}><DescendingIcon /></div>
                        )}
                    </button>
                ) : (
                    <p className="font-semibold text-nowrap text-default text-[14px]">{label}</p>
                )}

                {columnMetadata}

                
            </div>
        </th>
    )
}